import { Box, Typography, useTheme } from '@mui/material'
import { OnlineStatusIcon } from './OnlineStatusChip'

// Total / Online / Offline counts as small pills (Users toolbar, Outposts panel)
const OnlineCountPills = ({ total, online, offline = total - online, totalIcon, size = 'medium' }) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const line = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'
  const small = size === 'small'

  const stats = [
    { label: 'Total', value: total, icon: totalIcon },
    { label: 'Online', value: online, icon: <OnlineStatusIcon online size={small ? 16 : 18} /> },
    { label: 'Offline', value: offline, icon: <OnlineStatusIcon online={false} size={small ? 16 : 18} /> },
  ]

  return (
    <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
      {stats.map((stat) => (
        <Box
          key={stat.label}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            height: small ? 30 : 36,
            px: small ? 1.25 : 1.5,
            borderRadius: 2,
            border: `1px solid ${line}`,
            backgroundColor: theme.palette.background.alt,
          }}
        >
          {stat.icon}
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
            {stat.label}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, color: theme.palette.secondary[200] }}>
            {stat.value}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default OnlineCountPills
